export default "__VITE_PUBLIC_ASSET__29f6f2d4__"